<script setup>
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  postId: {
    type: Number,
    required: true,
  },
});
const emits = defineEmits(['request-close', 'request-submit']);
</script>

<template>
  <div v-if="isShow">
    <div :class="{modModalWindow: true, mdPopUp: true, isShow}">
      <div class="modModalTitleContainer">
        <p class="pFont16 pFontBold">SNSでシェア</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          @click="emits('request-close')"
        >
      <span class="lyBlock lyW24px"><img
        :src="siteUrl+'images/iconClose.svg'"
        loading="lazy"
        alt="" width="30"
        height="31"
      ></span>
          とじる
        </button>
      </div>
      <div class="modModalBottomWrapper">
        <div class="lyPd16">
          <p class="lyMb16 pFont14">どのSNSでシェアしましょうか？</p>
          <slot></slot>
        </div>
        <div class="lyMtAuto">
          <div class="lyPd16 pBackColorGray4">
            <ul class="lyHorizontalCnt">
              <li class="lyMr8">
                <a
                  :href="'https://twitter.com/intent/tweet?url='+encodeURIComponent(siteUrl+'place/'+postId)"
                  target="_blank"
                  class="lyW74px"
                ><img
                  :src="siteUrl+'images/shareX.svg'"
                  width="74"
                  height="25"
                  loading="lazy"
                  alt="このお題をXでシェア"
                ></a>
              </li>
              <li class="lyMr8">
                <a
                  :href="'https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(siteUrl+'place/'+postId)+'&amp;src=sdkpreparse'"
                  target="_blank"
                  class="lyW74px"
                ><img
                  :src="siteUrl+'images/shareLine.svg'"
                  width="74"
                  height="25"
                  loading="lazy"
                  alt="このお題をLINEでシェア"
                ></a>
              </li>
              <li>
                <a
                  :href="'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(siteUrl+'place/'+postId)+'&amp;src=sdkpreparse'"
                  target="_blank"
                  class="lyW74px"
                ><img
                  :src="siteUrl+'images/shareFacebook.svg'"
                  width="74"
                  height="25"
                  loading="lazy"
                  alt="このお題をfacebookでシェア"
                ></a>
              </li>
            </ul>
          </div>
          <div class="lyHorizontal pBorderTop2pxSolidGray4">
            <p class="lyW100 pBorderRight2pxSolidGray4">
              <button
                type="button"
                class="lyW100 lyPt16 lyPb16 pFont14 pFontBold"
                @click="emits('request-close')"
              >とじる</button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>